export const resetSuccessInfo = {
  text: "Password changed successfully",
  subtext:
    " Your account password has been successfully changed. Please login to CLAP Royalty with your new Password.",
  buttonTitle: "Continue to Login",
};

export const resetReqInfo = {
  text: "Password Reset",
  subtext: "Please enter your new password and repeat it.",
  buttonTitle: "Save",
};
